<template>

    <budgets
        :budgets-url="route('api.v1.financial.budgets.index')"
        :categories-url="route('api.v1.financial.budgets.categories.index')"
    ></budgets>

</template>

<script>

    import Budgets from "../../components/Business/Budgets/Budgets";

    export default {

        components: {
            Budgets,
        },

        metaInfo: {
            title:'Budgets',
        },

        name:'FinancialBudgets',

    }

</script>
